@if (strategy) {
  <div class="delay">
    <h3>Delay-strategy</h3>
    <div class="body">
      <mat-form-field>
        <mat-label>Enter the strategy title</mat-label>
        <input matInput type="text" placeholder="" [(ngModel)]="strategy.title" autocomplete="off">
      </mat-form-field>
      <div fxFlexLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
        <mat-form-field fxFlex style="min-width: 50px;">
          <mat-label>Duration (format dd:hh:mm)</mat-label>
          <input matInput type="text" placeholder="" [(ngModel)]="strategy.duration" autocomplete="off">
        </mat-form-field>
        <div fxFlex style="min-width: 50px;">
          Duration: {{ displayDuration(strategy?.duration) }}
        </div>
      </div>
      <div fxFlexLayout="row" fxLayoutAlign="space-between" fxLayoutGap="20px">
        <mat-form-field style="min-width: 50px;">
          <mat-label>Start time</mat-label>
          <input matInput type="text" [matDatepicker]="startDate" placeholder="" [(ngModel)]="startTime">
          <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
          <mat-datepicker #startDate></mat-datepicker>
        </mat-form-field>
        <mat-form-field style="min-width: 50px;">
          <mat-label>End time</mat-label>
          <input matInput type="text" [matDatepicker]="endDate" placeholder="" [(ngModel)]="endTime">
          <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
          <mat-datepicker #endDate></mat-datepicker>
        </mat-form-field>
      </div>
      <br/>
      <br/>
    </div>
  </div>
}

